var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecretQuestion(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "invisible_box",
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24,2.1,6,8.1V26.3c0,9.1,13.3,17.2,17,19.4a1.8,1.8,0,0,0,2,0c3.8-2.1,17-10.3,17-19.4V8.1ZM38,26.3c0,5-7.1,11.4-14,15.4C11.4,33.9,10,28.4,10,26.3V11L24,6.3,38,11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3,12.1A8.8,8.8,0,0,0,15,18.9a2,2,0,0,0,4,0,5.3,5.3,0,0,1,1.8-3.8,5.3,5.3,0,0,1,4.2-1,4.9,4.9,0,0,1,1.2,9.3,7.1,7.1,0,0,0-3.7,3.9,2,2,0,0,0,1.1,2.6h.8a1.9,1.9,0,0,0,1.8-1.3A3.7,3.7,0,0,1,27.8,27a8.9,8.9,0,0,0-2-16.8A8.5,8.5,0,0,0,18.3,12.1Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 36,
    r: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecretQuestion);
export default __webpack_public_path__ + "static/media/secret-question.0966facd4299757787c4f8ed634fd795.svg";
export { ForwardRef as ReactComponent };